import {
  FETCH_SIMILAR_ITEMS_SUCCESS,
  FETCH_SIMILAR_ITEMS_FAILURE,
  FETCH_SIMILAR_ITEMS_REQUEST,
  UPDATE_SIMILAR_ITEMS
} from '../../actionTypes/similarItemsActionTypes'

const initialState = {
  data: {},
  meta: {}
}

const transformData = ({ partNumber, type, syteResponse }) => {
  const maxRecs = 12 // max amount of recs to show
  const similarItemsRecs = syteResponse.splice(0, maxRecs)
  const transformedData = similarItemsRecs.map(rec => ({
    id: rec.sku,
    type,
    attributes: {
      score: 0
    },
    meta: {
      entity: partNumber
    }
  }))
  return transformedData
}

const buildRequestState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {})
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: false
      }
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber } = payload
  const syteResponse = transformData(payload)
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        products: syteResponse
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: true
      }
    }
  }
  return newState
}

const buildFailureState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber, errorDetail } = payload

  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {})
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail,
        requestDone: true
      }
    }
  }
  return newState
}

const updateSimilarItems = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber, data: payloadData = {} } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {}),
        ...payloadData
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        requestDone: true
      }
    }
  }
  return newState
}

const similarItemsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_SIMILAR_ITEMS_SUCCESS:
      return buildSuccessState(state, payload)

    case FETCH_SIMILAR_ITEMS_FAILURE:
      return buildFailureState(state, payload)

    case FETCH_SIMILAR_ITEMS_REQUEST:
      return buildRequestState(state, payload)

    case UPDATE_SIMILAR_ITEMS:
      return updateSimilarItems(state, payload)

    default:
      return state
  }
}

export { initialState, similarItemsReducer }
